import { IconButton } from '../icon-button/IconButton';
import { withPersonalizedIconButtonStyle } from '../icon-button/withPersonalizedIconButtonStyle';
import { styles } from './IconGhostButton.styles';

export const IconGhostButton = withPersonalizedIconButtonStyle(IconButton, styles);
